// extracted by mini-css-extract-plugin
export default {"root":"_1dhMl","stats":"_2Du9W","boosted":"_3bUCf","boosted-text":"gFuHG","boostedText":"gFuHG"};